import { FC, useState } from "react";
import { ColorPickerPopup, OpacityPopup } from "shared/ui";
import type { BackgroundSettings } from "../model";
import styles from "./styles/ToolSettingsModal.module.css";

type OpenPopup = "color" | "opacity" | null;

interface Props {
  value: BackgroundSettings;
  onChange: (value: BackgroundSettings) => void;
}

export const BackgroundSection: FC<Props> = ({ value, onChange }) => {
  const [open, setOpen] = useState<OpenPopup>(null);
  const toggle = (p: OpenPopup) => setOpen((prev) => (prev === p ? null : p));

  return (
    <div className={styles.mainLineRow}>
      <span className={styles.mainLineLabel}>Background</span>
      <div className={styles.btnGroup}>
        <div className={styles.btnWrap}>
          <button className={styles.mainLineBtn} onClick={() => toggle("color")}>
            <span className={styles.colorPreview} style={{ backgroundColor: value.color }} />
          </button>
          {open === "color" && (
            <ColorPickerPopup
              color={value.color}
              onChange={(color) => onChange({ ...value, color })}
              onClose={() => setOpen(null)}
            />
          )}
        </div>
        <div className={styles.btnWrap}>
          <button className={styles.mainLineBtn} onClick={() => toggle("opacity")}>
            <span>{value.opacity}%</span>
          </button>
          {open === "opacity" && (
            <OpacityPopup
              opacity={value.opacity}
              onChange={(opacity) => onChange({ ...value, opacity })}
              onClose={() => setOpen(null)}
            />
          )}
        </div>
      </div>
    </div>
  );
};
